var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    rx: 10,
    fill: "#FF4D61"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8061 15C28.6889 15 14 29.6889 14 47.8115C14 62.3066 23.3999 74.6035 36.4382 78.9437C38.0793 79.2441 38.6772 78.2311 38.6772 77.36C38.6772 76.5832 38.6499 74.5189 38.6336 71.7815C29.5067 73.7639 27.5817 67.3826 27.5817 67.3826C26.0895 63.594 23.9378 62.5851 23.9378 62.5851C20.9588 60.5481 24.1631 60.5891 24.1631 60.5891C27.4561 60.8225 29.1886 63.9708 29.1886 63.9708C32.1158 68.9841 36.8683 67.5355 38.7373 66.6973C39.0363 64.577 39.8814 63.1312 40.8207 62.3107C33.5356 61.4833 25.8751 58.6668 25.8751 46.0954C25.8751 42.5143 27.1544 39.5844 29.2528 37.2907C28.9156 36.4607 27.7892 33.1253 29.5736 28.6076C29.5736 28.6076 32.3287 27.7257 38.5967 31.9717C41.2139 31.244 44.0209 30.8794 46.8102 30.8672C49.5967 30.8794 52.4037 31.244 55.025 31.9717C61.2888 27.7257 64.0385 28.6076 64.0385 28.6076C65.8284 33.1253 64.702 36.4607 64.3648 37.2907C66.4673 39.5844 67.7384 42.5143 67.7384 46.0954C67.7384 58.6995 60.0656 61.4724 52.7559 62.2847C53.9355 63.2978 54.984 65.2992 54.984 68.3615C54.984 72.7468 54.9444 76.2856 54.9444 77.36C54.9444 78.2393 55.5342 79.2605 57.1999 78.9396C70.2273 74.5913 79.6189 62.3025 79.6189 47.8115C79.6189 29.6889 64.9286 15 46.8061 15Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/git.4a47bb960719c6e37153b86f8600bebf.svg";
export { ForwardRef as ReactComponent };